<template>
<transition name="fade">
<div class="ink" @click="click">
	{{ manufacturer }}
	<br>
	{{ name }}
	<span v-if="new_description">(*)</span>
	<br>
	<img :src="file">
</div>
</transition>
</template>

<script>
export default {
	name: 'Ink',
	props: ['info'],
	computed: {
		full_name() {
			let s = this.info.manufacturer;
			if (this.info.series) {
				s += " " + this.info.series;
			}
			s += " " + this.info.name;
			return s;
		},
		name() {
			return this.info.name;
		},
		new_description() {
			return !!this.info.new_description;
		},
		manufacturer() {
			let s = this.info.manufacturer;
			if (this.info.series) {
				 s += " " + this.info.series;
			}
			return s;
		},
		series() {
			return this.info.series;
		},
		file() {
			return "/swablib/inks_small/" + this.info.ident + ".jpg";
		},
	},
	methods: {
		click() {
			let path = "/ink/" + this.info.ident;
			console.log("Opening " + path);
			this.$router.push({ path: path });
		}
	},
}
</script>

<style scoped>

div.ink {
	width: 15em;
	padding: 0.5em 1em 0.2em 1em;
	margin: 0.6em;
	box-shadow: 3px 3px 5px grey;
	border: 1px solid #ccc;
	text-align: left;
	user-select: none;
	transition: all 0.3s ease;
	background: #e0e0e0;
	color: #888;
}

div.ink:hover {
	background: #ffffff;
}

div.ink img {
	margin-top: 0.7em ! important;
	margin-bottom: 0 ! important;
	margin-right: 0 ! important;
	margin-left: 0 ! important;
	width: 100%;
	border: none ! important;
	padding: 0 ! important;
}

.fade-enter-active, .fade-leave-active {
	transition: opacity transform 1s;
}

.fade-enter {
	opacity: 0;
	transform: translateX(100%);
}

.fade-enter-to {
	opacity: 1;
}

.fade-leave {
}

.fade-leave-to {
	opacity: 0;
	transform: translateX(100%);
}

</style>



// WEBPACK FOOTER //
// src/components/Ink.vue